export type SetupSection = "account" | "content" | "team";

export interface OnboardingStepResponse {
    step: string;
    completed: boolean;
    section: SetupSection;
    notApplicable: boolean;
    dismissible: boolean;
    route: string;
}

export const ASAP_RECIPIENTS_STEP = "setupRecipients";
export const ASAP_QR_STEP = "shareAccess";
export const STEPS_NEEDING_ASAP_FORM = [ASAP_RECIPIENTS_STEP, ASAP_QR_STEP];

export function isAsapStepList(
    steps: OnboardingStepResponse[] | null | undefined,
): boolean {
    return (steps ?? []).some((step) =>
        STEPS_NEEDING_ASAP_FORM.includes(step.step),
    );
}
